<app-quotation-message *ngIf="!isRFQVisible" (openEvent)="onOpenDetails($event)"></app-quotation-message>

<div class="container" *ngIf="isRFQVisible">

    <dx-toolbar class="rfq-toolbar">
        <dxi-item location="before" template="logoTemplate" locationItem></dxi-item>
        <dxi-item location="center" template="partyTemplate"></dxi-item>
        <dxi-item location="after" template="actionsTemplate"></dxi-item>

        <div *dxTemplate="let d of 'logoTemplate'">
            <img class="logo" src="assets/img/logo.png">
        </div>

        <div *dxTemplate="let d of 'partyTemplate'">
            <div id="partyNameAnchor" class="party-name-wrap">
                <span class="party-name">{{qs.party?.name}}</span>
                <span class="rank" *ngIf="qs.rfqModel.typeId == 1 && qs.rfqModel.statusId >= 12">
                    &nbsp;| {{L('BID_POSITION')}}: {{qs.partyRank}}
                </span>
            </div>
        </div>

        <div *dxTemplate="let d of 'actionsTemplate'" class="toolbar-actions">
            <i class="fa-solid fa-book manual-icon" (click)="openManual()" [title]="L('MANUAL')"></i>
            <dx-button type="danger" [text]="L('CANCEL_REGISTER')" (onClick)="qs.updateRFQRegister(false)"
                [visible]="qs.rfqModel.statusId == 5">
            </dx-button>
            <dx-button type="success" [text]="qs.partyRfq?.techStatus != 2 ? L('SEND_OFFER') : L('SEND_CLARIFICATION')"
                (onClick)="sendOffer($event)" [visible]="qs.rfqModel.statusId < 20 && qs.rfqModel.techStatus != 2"
                validationGroup="rfqPartyValidation">
            </dx-button>
        </div>
    </dx-toolbar>

    <dx-popover target="#partyNameAnchor" showEvent="mouseenter" hideEvent="mouseleave" position="bottom" [width]="300"
        [showTitle]="false">
        <div *dxTemplate="let d of 'content'" class="party-popover">
            <p><b>{{L('PIN')}}:</b> {{qs.party?.cif}}</p>
            <p><b>{{L('PHONE')}}:</b> {{qs.party?.phone}}</p>
            <p><b>{{L('EMAIL_ADDRESS')}}:</b> {{qs.party?.emailAddress}}</p>
        </div>
    </dx-popover>


    <div class="info-transport-row">
        <div class="rfq-info-panel">
            <div class="info-row">
                <span class="info-label">{{qs.rfqModel.typeId > 1 ? L('RFQ_NR') : L('AUCTION')}}</span>
                <span class="info-value rfq-no">{{qs.rfqModel.refNumber}}</span>
            </div>
            <div class="info-row">
                <span class="info-label">{{L('STATUS')}}</span>
                <span class="info-value status-badge">{{qs.rfqModel.statusName}}</span>
                <span *ngIf="qs.rfqModel.isSealed" class="info-value status-badge sealed">{{L("SEALED_OFFER")}}</span>
            </div>
            <div class="info-row">
                <span class="info-label">{{L('LIMIT_DATE_UPLOAD')}}</span>
                <span class="info-value">{{qs.rfqModel.dueDate | date:'dd.MM.yyyy HH:mm'}}</span>
            </div>
            <div class="info-row notes-row">
                <span class="info-label">{{L('BUYER_OBSERVATIONS')}}</span>
                <span class="notes-value">{{qs.rfqModel.partyNotes}}</span>
            </div>
        </div>
        <div class="transport-grid">
            <span class="box-title field-full">{{L('OFFER_DETAILS')}}</span>
            <div class="field-wrap">
                <label class="field-label">{{L('INCO_TERM')}} <span class="req">*</span></label>
                <dx-select-box [(value)]="qs.partyRfq.incoTerm" [dataSource]="qs.incoTerm" valueExpr="code"
                    displayExpr="name" [readOnly]="qs.partyRfq.isWinner || ![5,12].includes(qs.rfqModel.statusId)">
                    <dx-validator validationGroup="rfqPartyValidation">
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dx-validator>
                </dx-select-box>
            </div>
            <div class="field-wrap">
                <label class="field-label">{{L('EXECUTION_DAYS')}}</label>
                <dx-number-box [(value)]="qs.partyRfq.executionDays"
                    [readOnly]="qs.partyRfq.isWinner || ![5,12].includes(qs.rfqModel.statusId)">
                </dx-number-box>
            </div>
            <div class="field-wrap">
                <label class="field-label">{{L('PAYMENT_METHOD')}} <span class="req">*</span></label>
                <dx-select-box [(value)]="qs.partyRfq.paymentMethod" [dataSource]="qs.dsPaymentMethods"
                    valueExpr="value" displayExpr="name"
                    [readOnly]="qs.partyRfq.isWinner || ![5,12].includes(qs.rfqModel.statusId)">
                    <dx-validator validationGroup="rfqPartyValidation">
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dx-validator>
                </dx-select-box>
            </div>
            <div class="field-wrap" *ngIf="qs.partyRfq.paymentMethod == 1">
                <label class="field-label">{{L('PAYMENT_DAYS')}}</label>
                <dx-number-box [(value)]="qs.partyRfq.paymentDays"
                    [readOnly]="qs.partyRfq.isWinner || ![5,12].includes(qs.rfqModel.statusId)">
                </dx-number-box>
            </div>
            <div class="field-wrap">
                <label class="field-label">{{L('TRANSPORT_TERM')}} <span class="req">*</span></label>
                <dx-select-box [(value)]="qs.partyRfq.transportState" [dataSource]="qs.transportState" valueExpr="id"
                    displayExpr="name" [readOnly]="qs.partyRfq.isWinner || ![5,12].includes(qs.rfqModel.statusId)"
                    (onSelectionChanged)="transportStateChanged($event)">
                    <dx-validator validationGroup="rfqPartyValidation">
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dx-validator>
                </dx-select-box>
            </div>
            <div class="field-wrap" *ngIf="qs.partyRfq.transportState == 2">
                <label class="field-label">{{L('TRANSPORT_VALUE')}} <span class="req">*</span></label>
                <dx-number-box [(value)]="qs.partyRfq.transportValue"
                    [readOnly]="qs.partyRfq.isWinner || ![5,12].includes(qs.rfqModel.statusId)">
                    <dx-validator validationGroup="rfqPartyValidation">
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dx-validator>
                </dx-number-box>
            </div>
            <div class="field-wrap" *ngIf="qs.partyRfq.transportState == 2">
                <label class="field-label">{{L('CURRENCY')}}</label>
                <dx-select-box [(value)]="qs.partyRfq.transportCurrency" [dataSource]="qs.currency" valueExpr="id"
                    displayExpr="name" [readOnly]="qs.partyRfq.isWinner || ![5,12].includes(qs.rfqModel.statusId)">
                </dx-select-box>
            </div>
            <div class="field-wrap field-full">
                <label class="field-label">{{L('OBSERVATIONS_CLARIFICATIONS')}}</label>
                <dx-text-area [(value)]="qs.partyRfq.observations"
                    [readOnly]="qs.partyRfq.isWinner || qs.rfqModel.statusId >= 20">
                </dx-text-area>
                <span class="field-hint">{{L('TRANSPORT_DETAILS_SAVE_INFO')}}</span>
            </div>
        </div>
    </div>
    <p class="red-txt" style="font-size:12px">Atenție! Furnizorii au obligația de a încărca documentele tehnice exclusiv în secțiunea «Documente tehnice», iar oferta comercială exclusiv în secțiunea «Oferta comercială». În cazul în care documentele sunt încărcate în secțiunea greșită, oferta poate fi descalificată fără o solicitare ulterioară de clarificări.</p>
    <dx-tab-panel #tabPanel [animationEnabled]="true" [swipeEnabled]="false" [selectedIndex]="qs.panelIndex"
        [elementAttr]="{ class: 'panel-items'}">
        <dxi-item [title]="L('MATERIAL_LIST')" icon="product" [badge]="qs.rfqItems?.length || null"
            *ngIf="qs.rfqModel.id">
            <app-quotation-request></app-quotation-request>
        </dxi-item>
        <dxi-item [title]="L('REQUEST_DOCUMENTATION')" icon="attach" [badge]="qs.requestFile?.length || null"
            *ngIf="qs.rfqModel.id">
            <app-quotation-file [dsFile]="qs.requestFile" [allowAdd]="false" [allowDelete]="false">
            </app-quotation-file>
        </dxi-item>
        <dxi-item [title]="L('QUOTATION_LIST')" icon="money" [badge]="qs.quotationList.length || null"
            *ngIf="qs.rfqModel.id">
            <app-quotation-list></app-quotation-list>
        </dxi-item>
        <dxi-item [title]="L('OFFER_ATTACHMENTS')" icon="upload" [badge]="qs.rfqPartyFiles.length || null"
            *ngIf="qs.rfqModel.id">
            <app-quotation-file [dsFile]="qs.rfqPartyFiles"
                [allowAdd]="(!qs.isUpdateDisabled && qs.rfqModel.statusId == 5) || qs.discountVisible || qs.partyRfq.techStatus == 2"
                [allowDelete]="(!qs.isUpdateDisabled && qs.rfqModel.statusId == 5) || qs.discountVisible || qs.partyRfq.techStatus == 2">
            </app-quotation-file>
        </dxi-item>
        <dxi-item [title]="L('CLARIFICATIONS')" icon="comment" [badge]="qs.clarificationCount || null"
            *ngIf="qs.rfqModel.id">
            <app-clarification-list></app-clarification-list>
        </dxi-item>
        <dxi-item [title]="L('CLARIFICATION_FILES')" icon="attach"
            [badge]="qs.rfqPartyClarificationFiles.length || null" *ngIf="qs.partyRfq.techStatus == 2">
            <app-quotation-file [dsFile]="qs.rfqPartyClarificationFiles" [allowAdd]="false" [allowDelete]="false">
            </app-quotation-file>
        </dxi-item>
    </dx-tab-panel>
</div>

<dx-load-panel [(visible)]="qs.loadingVisible"></dx-load-panel>

<ibis-edit-popup [edit]="edit" [showAdd]="false" [width]="'90vw'">
    <app-quotation-item-edit [rfqItems]="qs.rfqItems" [currency]="qs.currency" [dsPaymentMethods]="qs.dsPaymentMethods"
        [readOnly]="false" [byMaterial]="qs.rfqModel.byMaterial"></app-quotation-item-edit>
</ibis-edit-popup>

<ibis-edit-popup [edit]="qs.clarificationEdit" [showAdd]="false">
    <app-add-clarification></app-add-clarification>
</ibis-edit-popup>